<template>
  <v-container fluid class="pa-4 rtl">
    <!-- Header -->
    <v-card class="header-card mb-4" elevation="2">
      <div class="d-flex align-center justify-space-between flex-wrap ga-3">
        <div>
          <div class="text-h5 font-weight-bold" style="color: #4a4f55">
            التخطيط الاستراتيجي وإعداد الموازنة وتنسيق التعافي
          </div>
          <div class="text-body-2 text-grey-darken-1 mt-1">
            مدى وجود خطط تشغيلية وموازنات وآليات تعافي
          </div>
        </div>
        <v-btn
          prepend-icon="mdi-arrow-right"
          variant="text"
          style="color: #4a4f55"
          @click="showView('pillar-governance')"
        >
          رجوع
        </v-btn>
      </div>
    </v-card>

    <!-- KPIs -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">3/9</div>
          <div class="kpi-label">لديها خطة تشغيلية سنوية</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">2/9</div>
          <div class="kpi-label">موازنة مُعتمدة ومنشورة</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">4/9</div>
          <div class="kpi-label">مشاركة في تنسيق التعافي</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">9/9</div>
          <div class="kpi-label">تفتقر لخطة التعافي</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-card class="table-card" elevation="1">
      <div class="table-header">التخطيط وإعداد الموازنة</div>
      <v-table class="custom-table">
        <thead>
          <tr>
            <th>المرفق</th>
            <th>خطة تشغيلية سنوية؟</th>
            <th>موازنة مُعتمدة؟</th>
            <th>مشاركة في لقاءات التنسيق؟</th>
            <th>خطة التعافي؟</th>
            <th>مؤشرات أداء مُحددة؟</th>
            <th>درجة التخطيط/100</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in facilities" :key="item.name">
            <td class="font-weight-bold">{{ item.name }}</td>
            <td>
              <v-chip
                :color="statusColor(item.annualPlan)"
                size="small"
                variant="flat"
                >{{ item.annualPlan }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="statusColor(item.approvedBudget)"
                size="small"
                variant="flat"
                >{{ item.approvedBudget }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="statusColor(item.coordination)"
                size="small"
                variant="flat"
                >{{ item.coordination }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="statusColor(item.recoveryPlan)"
                size="small"
                variant="flat"
                >{{ item.recoveryPlan }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="statusColor(item.kpis)"
                size="small"
                variant="flat"
                >{{ item.kpis }}</v-chip
              >
            </td>
            <td
              class="font-weight-bold"
              :class="scoreClass(item.planningScore)"
            >
              {{ item.planningScore }}
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </v-container>
</template>

<script setup>
const facilities = [
  {
    name: "مستشفى الصداقة التعليمي",
    annualPlan: "جزئي",
    approvedBudget: "نعم",
    coordination: "نعم",
    recoveryPlan: "لا",
    kpis: "لا",
    planningScore: 50,
  },
  {
    name: "مستشفى الأمراض النفسية",
    annualPlan: "لا",
    approvedBudget: "لا",
    coordination: "لا",
    recoveryPlan: "لا",
    kpis: "لا",
    planningScore: 15,
  },
  {
    name: "مجمع الشيخ عثمان",
    annualPlan: "نعم",
    approvedBudget: "نعم",
    coordination: "نعم",
    recoveryPlan: "لا",
    kpis: "جزئي",
    planningScore: 65,
  },
  {
    name: "مركز كود العثماني",
    annualPlan: "نعم",
    approvedBudget: "جزئي",
    coordination: "نعم",
    recoveryPlan: "لا",
    kpis: "جزئي",
    planningScore: 60,
  },
  {
    name: "مركز الممدارة",
    annualPlan: "نعم",
    approvedBudget: "نعم",
    coordination: "نعم",
    recoveryPlan: "لا",
    kpis: "كامل",
    planningScore: 78,
  },
  {
    name: "مركز المحاريق",
    annualPlan: "لا",
    approvedBudget: "لا",
    coordination: "لا",
    recoveryPlan: "لا",
    kpis: "لا",
    planningScore: 20,
  },
  {
    name: "مركز عبد القوي",
    annualPlan: "نعم",
    approvedBudget: "نعم",
    coordination: "نعم",
    recoveryPlan: "لا",
    kpis: "كامل",
    planningScore: 75,
  },
  {
    name: "مركز ماري ستبوس",
    annualPlan: "لا",
    approvedBudget: "لا",
    coordination: "لا",
    recoveryPlan: "لا",
    kpis: "لا",
    planningScore: 10,
  },
  {
    name: "جمعية حقوق الطفل",
    annualPlan: "جزئي",
    approvedBudget: "جزئي",
    coordination: "نعم",
    recoveryPlan: "لا",
    kpis: "جزئي",
    planningScore: 55,
  },
];

const statusColor = (value) => {
  if (value === "نعم" || value === "كامل") return "green";
  if (value === "جزئي") return "orange";
  return "red";
};

const scoreClass = (value) => {
  if (value >= 70) return "text-green-darken-2";
  if (value >= 40) return "text-orange-darken-2";
  return "text-red-darken-2";
};

const showView = (view) => console.log("Go to:", view);
</script>

<style scoped>
.rtl {
  direction: rtl;
}

.header-card {
  border-right: 5px solid #4a4f55;
  border-radius: 18px;
  padding: 20px;
}

.kpi-card {
  border-radius: 18px;
  padding: 20px;
  text-align: center;
}

.kpi-value {
  font-size: 34px;
  font-weight: 800;
}

.kpi-label {
  margin-top: 6px;
  font-size: 13px;
}

.danger {
  background: #fdecea;
  color: #c0392b;
}

.warning {
  background: #fff4e5;
  color: #d4821a;
}

.table-card {
  border-radius: 18px;
  overflow: hidden;
}

.table-header {
  padding: 18px;
  font-size: 18px;
  font-weight: 700;
  color: #3a3f47;
  border-bottom: 1px solid #eee;
}

.custom-table {
  direction: rtl;
}

:deep(th) {
  font-weight: 800 !important;
  color: #3a3f47 !important;
  white-space: nowrap;
}

:deep(td) {
  font-size: 14px;
  white-space: nowrap;
}
</style>
